import useSWR from "swr";

import { type Settings } from "./types";

const createSubHeaderFetcher =
  (country: string, language: string) => async () => {
    try {
      const url = `${
        import.meta.env.VITE__LOCALE_PREFIX
          ? `${import.meta.env.VITE__LOCALE_PREFIX}/`
          : "/"
      }${country}/${language}/saleslead/settings/headerconfig.json`;

      const res = await fetch(url);
      return await res?.json();
    } catch {
      return "";
    }
  };

export function useHeaderConfig(market: string, language: string) {
  const { data, isLoading, isValidating } = useSWR<Settings>(
    "headerConfig.json",
    createSubHeaderFetcher(market, language)
  );

  return { data, isLoading, isValidating };
}
